import React, { useState } from 'react';
import { Box } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { ColorModeProvider, useColorMode } from './context/ColorModeContext';
import Login from './auth/Login';
import Home from './pages/Home';
import DeviceControl from './pages/DeviceControl';
import { DeviceSelectionProvider } from './context/DeviceSelectionContext';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import AdminPanel from './pages/AdminPanel';
import AnalyticsPage from './pages/AnalyticsPage';
import Sidebar, { SIDEBAR_WIDTH } from './pages/sidebar';
import TopBar from './components/TopBar';
import HistoryPage from './pages/historyPage';
import AppBreadcrumbs from './components/AppBreadcrumbs';
import Preference from './pages/Preference';

const PrivateRoute = ({ children }) => {
  const { token } = useAuth();
  return token ? <>{children}</> : <Navigate to="/login" replace />;
};

const MainLayout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          minHeight: '100vh',
          width: { md: `calc(100% - ${SIDEBAR_WIDTH}px)` },
          ml: { md: `${SIDEBAR_WIDTH}px` },
        }}
      >
        <TopBar onMenuClick={() => setMobileOpen(true)} />
        <Box sx={{ p: { xs: 2, md: 3 } }}>
          <AppBreadcrumbs />
          {children}
        </Box>
      </Box>
    </Box>
  );
};

// Bridges the shared color mode into the Preference page (keeps its existing props API).
const PreferenceRoute = () => {
  const { mode, setMode } = useColorMode();
  return <Preference mode={mode} setMode={setMode} />;
};

const App = () => (
  <ColorModeProvider>
    <AuthProvider>
      <DeviceSelectionProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/history" element={<PrivateRoute><MainLayout><HistoryPage /></MainLayout></PrivateRoute>} />
            <Route path="/" element={<PrivateRoute><MainLayout><Home /></MainLayout></PrivateRoute>} />
            <Route path="/device" element={<PrivateRoute><MainLayout><DeviceControl /></MainLayout></PrivateRoute>} />
            <Route path="/admin" element={<PrivateRoute><MainLayout><AdminPanel /></MainLayout></PrivateRoute>} />
            <Route path="/analytics" element={<PrivateRoute><MainLayout><AnalyticsPage /></MainLayout></PrivateRoute>} />
            <Route path="/preference" element={<PrivateRoute><MainLayout><PreferenceRoute /></MainLayout></PrivateRoute>} />
          </Routes>
        </Router>
      </DeviceSelectionProvider>
    </AuthProvider>
  </ColorModeProvider>
);

export default App;
